<template>
  <div v-if="pageType == 1" class="user-list">
    <div class="search-bar flex">
      <div class="left">
        <el-date-picker
          v-model="daas"
          type="daterange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeTime"
        >
        </el-date-picker>
        <el-select
          v-model="searchParam.status"
          placeholder="考试状态"
          clearable
          style="margin-left: 10px"
          @clear="getList"
        >
          <el-option value="1" label="未开始"></el-option>
          <el-option value="2" label="已完成"></el-option>
        </el-select>
        <el-input
          v-model="searchParam.search_keyword"
          placeholder="输入考试名称筛选"
          clearable
          @clear="getList"
        ></el-input>
        <el-button @click="getList">筛选</el-button>
      </div>
      <div class="right">
        <el-button type="primary" @click="exportDetail">导出名单</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="user_name" label="学生名称"> </el-table-column>
        <el-table-column prop="user_mobile" label="手机号"> </el-table-column>
        <el-table-column prop="school" label="所在校区"> </el-table-column>
        <el-table-column prop="paper_title" label="考试名称"> </el-table-column>
        <el-table-column prop="course_title" label="关联课程"> </el-table-column>
        <el-table-column prop="address" label="考试地点"> </el-table-column>
        <el-table-column prop="score" label="考试成绩">
          <template slot-scope="scope">
            {{ scope.row.score }}
          </template>
        </el-table-column>
        <el-table-column prop="exam_time" label="考试时间"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
  <online v-else-if="pageType == 2" :row-msg="rowMsg"></online>
  <offline v-else></offline>
</template>

<script>
import { examRecord, exportExam } from "@/api/student.js";
import { mixin } from "@/mixins/pagination.js";
import online from "./onlineExam.vue";
import offline from "./offlineExam.vue";
export default {
  components: {
    online,
    offline,
  },
  mixins: [mixin],
  props: ["userMsg"],
  data() {
    return {
      rowMsg: {},
      pageType: 1,
      daas: [],
      searchParam: {
        keyword_search: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    exportDetail() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        user_uuid: this.userMsg.user_uuid,
      };
      console.log(param);

      exportExam(param);
    },
    changeTime(val) {
      if (val) {
        this.searchParam = {
          ...this.searchParam,
          start_time: val[0],
          end_time: val[1],
        };
      } else {
        this.searchParam = {
          ...this.searchParam,
          start_time: "",
          end_time: "",
        };
        this.getList();
      }
    },
    toDetail(row) {
      this.rowMsg = row;
      if (row.exam_type == 1) {
        this.pageType = 2;
      } else {
        this.pageType = 2;
      }
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        user_uuid: this.userMsg.user_uuid,
      };
      console.log(param);
      const res = await examRecord(param);
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
      console.log(res);
    },
    deleteItem() {},
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
